import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 900 900"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#fff",
  d: "M504.908 750h334.568a60.945 60.945 0 0 0 30.269-8.037 60.252 60.252 0 0 0 22.155-21.964 59.566 59.566 0 0 0 8.1-30.002 59.563 59.563 0 0 0-8.127-29.995L667.187 274.289a60.253 60.253 0 0 0-22.151-21.96 60.944 60.944 0 0 0-30.263-8.038 60.94 60.94 0 0 0-30.262 8.038 60.245 60.245 0 0 0-22.151 21.96l-57.452 98.69-112.327-192.986a60.287 60.287 0 0 0-22.161-21.957A60.98 60.98 0 0 0 340.151 150a60.974 60.974 0 0 0-30.268 8.036 60.282 60.282 0 0 0-22.162 21.957L8.126 660.002A59.569 59.569 0 0 0 0 689.997a59.569 59.569 0 0 0 8.1 30.002 60.254 60.254 0 0 0 22.155 21.964A60.944 60.944 0 0 0 60.524 750h210.014c83.21 0 144.574-36.225 186.798-106.899l102.513-175.956 54.908-94.166 164.79 282.855H559.849L504.908 750Zm-237.794-94.263-146.563-.033 219.698-377.118L449.87 467.145l-73.396 126.03c-28.041 45.855-59.897 62.562-109.36 62.562Z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render() { return h(NuxtIcon, {icon: {render}}) } }